module.exports = __webpack_public_path__ + "img/rear-5.fc75885b.jpg";